<template>
  <div >
    <Loader v-if="this.isLoading"></Loader>
    <div id="map" ref="map" class="map-container"></div>
    <panel></panel>
    <MapDash defaultCurrentMapView = "3"></MapDash>
    <div class="legend">
      <img v-if="this.isLayerParamsVisible && this.areDensityMapsVisible" :src=this.legendURL alt="">
    </div>
    <div id="popup" ref="popup" class="popup">
      Estación: <span class="station-name" id="station-name" ref="stationname"></span>
    </div>
  </div>
</template>

<script>
import { loadModules } from 'esri-loader'
import configMap from '@/components/configMap'
import { mapGetters } from 'vuex'
import panel from '@/components/map/panel'
import {getData,getOutsideData, checkWorkspaces} from './../services/api'
var convert = require('xml-js')
import Loader from '@/components/common/loader.vue'
import MapDash from '@/components/MapDash'



export default {
  name: 'Map',
  props: {
    selectlayer: Number,
  },
  data: function () {
    return {
      basemap: '',
      map: '',
      view: '',
      layerMosaicsGlobal: '',
      layerMosaicsCampaigns: [],
      layerMosaicsGeneral: [],
      layerSonarsGlobal: '',
      layerSonarsCampaigns: [],
      layerSonarsGeneral: [],
      layerParamsDensityMap: null,
      GraphicsLayerMosaicsCampaign: '' ,
      PointGraphicMosaicsCampaigns: [],
      coordinatesMosaicsCampaigns: [],
      currentLayerMosaicsCampaigns: [],
      GraphicsLayerSonarsCampaign: '' ,
      PointGraphicSonarsCampaigns: [],
      coordinatesSonarsCampaigns: [],
      currentLayerSonarsCampaigns: [],
      oceanographicParametersMarkers: '',
      platformGraphicsLayer : '',
      platforms: [],
      oceanographicParameters: [],
      regularGraphic: {
        type: "simple-marker",
        color: [52, 152, 219],
        outline: {
          color: [255, 255, 255],
          width: 1
        }
      },
      selectedGraphic: {
        type: "simple-marker",
        color: [255, 169, 3],
        outline: {
          color: [255, 255, 255],
          width: 1
        }
      },
      selectedGraphicObject: null,
      layerBathymetryGlobal: '',
      layerBathymetryCampaigns: [],
      layerBathymetryGeneral: [],
      currentLayerBathymetryCampaigns: [],
      GraphicsLayerBathymetryCampaign: '',
      PointGraphicBathymetryCampaigns: [],
      coordinatesBathymetryCampaigns: [],
      reloadLayer: '',
      statusReload: true,
      selectedPointId: '',
    }
  },
  computed:{
    ...mapGetters([
      'isLayerMosaicsVisible',
      'isGlobalMosaicVisible',
      'areCampaignMosaicsVisible',
      'mosaicsCampaignsList',
      'mosaicsCampaignsListFiltered',
      'isLayerSonarsVisible',
      'isGlobalSonarVisible',
      'areCampaignSonarsVisible',
      'sonarsCampaignsList',
      'sonarsCampaignsListFiltered',
      'isLayerParamsVisible',
      'areStationsVisible',
      'areDensityMapsVisible',
      'paramsCampaignsList',
      'paramsCampaignsListFiltered',
      'paramsCampaignSelected',
      'densitySelectedParam',
      'isLayerBathymetryVisible',
      'isGlobalBathymetryVisible',
      'areCampaignBathymetryVisible',
      'bathymetryCampaignsList',
      'bathymetryCampaignsListFiltered',
      'bathymetryUid',
      'platform_id',
      'isLoading',
      'legendURL',
      'theme',
    ])
  },
  components: {
    configMap,
    panel,
    Loader,
    MapDash
  },
  beforeMount() {
  },
  mounted () {
    // if(this.isLayerParamsVisible) {
    //   this.$store.dispatch('changeMapLayersState', {layer: 'params'})
    // }
    // if(this.isLayerMosaicsVisible) {
    //   this.$store.dispatch('changeMapLayersState', {layer: 'mosaics'})
    // }
    // if(this.isLayerBathymetryVisible) {
    //   this.$store.dispatch('changeMapLayersState', {layer: 'bathymetry'})
    // }
    this.getPlatformList()
    this.loadBaseMap()
    this.loadScaleBar()
    

    checkWorkspaces()
       .then(res=> {
         if (res.data.workspaces.workspace.some(elm => elm.name === process.env.VUE_APP_WORKSPACE)) {
              this.loadMosaicsGlobal()
              this.loadSonarsGlobal()
              this.loadBathymetryGlobal()
        }
        else {
              this.$noty.error("El workspace no existe en Geoserver")
        }
    })
    this.handleClickEvent()
  },

  watch: {
    // MOSAICOS
    'isLayerMosaicsVisible': function () {
      this.switchMosaicsGlobal()
      this.switchMosaicsCampaigns()
    },
    'isGlobalMosaicVisible': function () {
      this.switchMosaicsGlobal()
    },
    'areCampaignMosaicsVisible': function () {
      this.switchMosaicsGlobal()
      this.switchMosaicsCampaigns()
    },
    'mosaicsCampaignsList': function () {
      this.loadMosaicsCampaigns()
    },
    'mosaicsCampaignsListFiltered': function () {
      this.filterMosaicsCampaigns()
    },
    // SONAR
    'isGlobalSonarVisible': function () {
      this.switchSonarsGlobal()
    },
    'isLayerSonarsVisible': function () {
      this.switchSonarsGlobal()
      this.switchSonarsCampaigns()
    },
    'areCampaignSonarsVisible': function () {
      this.switchSonarsCampaigns()
    },
    'sonarsCampaignsList': function () {
      this.loadSonarsCampaigns()
    },
    'sonarsCampaignsListFiltered': function () {
      this.filterSonarsCampaigns()
    },
    // PARAMS
    'isLayerParamsVisible': function () {
      this.switchParamsStations()
      this.switchParamsDensity()
    },
    'areStationsVisible': function () {
      this.switchParamsStations()
    },
    'areDensityMapsVisible': function () {
      this.switchParamsDensity()
    },
    'densitySelectedParam': function () {
      this.switchParamsDensity()
    },
    'paramsCampaignSelected': function () {
      this.switchParamsDensity()
    },
    // BATHYMETRY
    'isLayerBathymetryVisible': function () {
      this.switchBathymetryGlobal()
      this.switchBathymetryCampaigns()
    },
    'isGlobalBathymetryVisible': function () {
      this.switchBathymetryGlobal()
    },
    'areCampaignBathymetryVisible': function () {
      this.switchBathymetryCampaigns()
    },
    'bathymetryCampaignsList': function () {
      this.loadBathymetryCampaigns()
    },
    'bathymetryCampaignsListFiltered': function () {
      this.filterBathymetryCampaigns()
    },
    // THEME
    'theme': function () {
      this.loadBaseMap()
    }
  },
  methods: {
    loadBaseMap() {
        this.$store.dispatch('changeLoaderStatus', true)
        if (this.view) {
          // destroy the map view
          this.view.container = null;
        }
        var portalItemId = ''
        if(this.theme == 'dark'){
          portalItemId = '4a384576a23c48079c545419c62e24fa'
        }
        else{
          portalItemId = '6b4764e99107496f9193e4b68a77b73a'
        }
        
        loadModules(['esri/Map', 'esri/views/MapView', 'esri/Basemap', 'esri/layers/MapImageLayer'], {css: true})
        .then(([ArcGISMap, MapView, Basemap, MapImageLayer]) => {
          this.basemap = new Basemap({
            portalItem: {
             id: portalItemId  // Webmap is hosted in CTN's ArcGIS Online account --> /OOMMUR/oommur_nova
             //id: '4a384576a23c48079c545419c62e24fa' 
            }
          });

          this.map = new ArcGISMap({
            basemap: this.basemap
          });
          this.view = new MapView({
            container: 'map',
            map: this.map,
            center: [-0.79, 37.72],
            zoom: 11
          })

        })
        .then(() => {
          this.$store.dispatch('changeLoaderStatus', false)
          var layer = 3
          if(this.selectlayer)
            layer = this.selectlayer 
          switch(layer){
                case 2:
                  //this.$store.dispatch('changeMapLayersState', {layer: 'params'})
                  break
                case 3:
                  this.$store.dispatch('changeMapLayersState', {layer: 'mosaics'})
                  break
                case 4:
                  this.$store.dispatch('changeMapLayersState', {layer: 'bathymetry'})
                  break
                case 5:
                  this.$store.dispatch('changeMapLayersState', {layer: 'sonars'})
                  break
              }
        })
    },

    // MOSAICS METHODS
    loadMosaicsGlobal () {
      loadModules(['esri/views/MapView', 'esri/layers/WMSLayer','esri/layers/GroupLayer'], {css: true})
      .then(([MapView, WMSLayer, GroupLayer]) => {
        this.layerMosaicsGlobal = new WMSLayer({
          url: process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/Global_mosaic/wms"
        })
        // Inicializo una capa auxiliar necesaria para poder actualizar las subcapas de mosaicos/batimetrías al usar las funciones de filtrado
        this.reloadLayer = new GroupLayer();
      })
    },
    loadMosaicsCampaigns () {
      loadModules(['esri/views/MapView', 'esri/layers/WMSLayer', 'esri/layers/GroupLayer'], {css: true})
      .then(async ([MapView, WMSLayer,GroupLayer]) => {
        if(this.mosaicsCampaignsList.length>0){
          if(this.layerMosaicsGeneral.length == 0){
            this.layerMosaicsGeneral = new GroupLayer()
            this.map.add(this.layerMosaicsGeneral)
            this.layerMosaicsCampaigns = []
          }
          this.currentLayerMosaicsCampaigns = []

          if(this.layerMosaicsCampaigns.length == 0){
            for (var i=0; i< this.mosaicsCampaignsList.length; i++){
              this.layerMosaicsCampaigns.push([
                this.mosaicsCampaignsList[i].campaign_id,
                new WMSLayer({
                  url: process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/mosaic_campaign_" + this.mosaicsCampaignsList[i].campaign_id + "/wms"
                })
              ]);

              this.currentLayerMosaicsCampaigns.push(this.mosaicsCampaignsList[i].campaign_id)
              var url = process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/mosaic_campaign_" + this.mosaicsCampaignsList[i].campaign_id + "/wms?request=GetCapabilities"
              await getOutsideData(url).then(res=> {
                var result = convert.xml2json(res.data, {compact: true})
                this.coordinatesMosaicsCampaigns.push(JSON.parse(result))
                if(this.mosaicsCampaignsList.length == this.coordinatesMosaicsCampaigns.length){
                   this.loadMosaicsMarker()
                }
              })
            }
          }else {
            var layerMosaicsCampaignsAux = this.layerMosaicsCampaigns
            for (var i=0; i< this.mosaicsCampaignsList.length; i++){
              var layerExist = false
              for (let j = 0; j < layerMosaicsCampaignsAux.length; j++) {
                if(this.mosaicsCampaignsList[i].campaign_id == layerMosaicsCampaignsAux[j][0]){
                  layerExist = true
                  break
                }
              }
              // Solo añadimos la capa si no existía previamente
              if(!layerExist){
                this.layerMosaicsCampaigns.push([
                  this.mosaicsCampaignsList[i].campaign_id,
                  new WMSLayer({
                    url: process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/mosaic_campaign_" + this.mosaicsCampaignsList[i].campaign_id + "/wms"
                  })
                ]);

                this.currentLayerMosaicsCampaigns.push(this.mosaicsCampaignsList[i].campaign_id)
                var url = process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/mosaic_campaign_" + this.mosaicsCampaignsList[i].campaign_id + "/wms?request=GetCapabilities"
                await getOutsideData(url).then(res=> {
                  var result = convert.xml2json(res.data, {compact: true});
                  this.coordinatesMosaicsCampaigns.push(JSON.parse(result))
                  if(this.mosaicsCampaignsList.length == this.coordinatesMosaicsCampaigns.length){
                    this.loadMosaicsMarker()
                  }
                })
              }
            }
          }
        }
      })
    },
    loadMosaicsMarker () {
      loadModules(['esri/views/MapView', "esri/Graphic","esri/layers/GraphicsLayer"], {css: true})
        .then(([MapView, Graphic,GraphicsLayer]) => {
          this.GraphicsLayerMosaicsCampaign = new GraphicsLayer()
          this.map.add(this.GraphicsLayerMosaicsCampaign)
          this.PointGraphicMosaicsCampaigns = []
          var i = 0
          this.coordinatesMosaicsCampaigns.forEach(item => {
            this.PointGraphicMosaicsCampaigns.push(new Graphic({
                geometry: {
                  type: "point",
                  longitude: item.WMS_Capabilities.Capability.Layer.EX_GeographicBoundingBox.eastBoundLongitude['_text'],
                  latitude: item.WMS_Capabilities.Capability.Layer.EX_GeographicBoundingBox.northBoundLatitude['_text'],

                },
                symbol: this.regularGraphic,
                attributes: {
                  //Name: item.WMS_Capabilities.Capability.Layer.Layer.Name['_text'],
                  Name: this.mosaicsCampaignsList[i].name,
                  Date: this.mosaicsCampaignsList[i].date,
                  index: i
                },
                popupTemplate: {
                  title: "{Name}",
                  content: "<p>{Date}<p>",
                  actions: [{
                      title: "Ver detalles",
                      id: 'view_details',
                      index: i,
                      tipo: 'mosaic',
                      image: "Measure_Distance16.png"
                  }],
                }
            }))
            i++
          })
      })

    },

    switchMosaicsGlobal () {
      if(this.isGlobalMosaicVisible && this.isLayerMosaicsVisible){
        this.map.add(this.layerMosaicsGlobal, 0)
      }else{
        this.map.remove(this.layerMosaicsGlobal, 0)
      }
    },
    switchMosaicsCampaigns () {
      if(this.areCampaignMosaicsVisible && this.isLayerMosaicsVisible){
        for (var i=0; i< this.mosaicsCampaignsListFiltered.length; i++){
          for (var j=0; j<this.layerMosaicsCampaigns.length; j++){
            if(this.mosaicsCampaignsListFiltered[i].campaign_id == this.layerMosaicsCampaigns[j][0]){
              this.layerMosaicsGeneral.add(this.layerMosaicsCampaigns[j][1], 0)
              this.GraphicsLayerMosaicsCampaign.add(this.PointGraphicMosaicsCampaigns[j])
            }
          }
        }
        this.map.add(this.layerMosaicsGeneral)
      }
      else {
        for (var i=0; i< this.mosaicsCampaignsListFiltered.length; i++){
          for (var j=0; j<this.layerMosaicsCampaigns.length; j++){
            if(this.mosaicsCampaignsListFiltered[i].campaign_id == this.layerMosaicsCampaigns[j][0]){
              this.layerMosaicsGeneral.remove(this.layerMosaicsCampaigns[j][1], 0)
              this.GraphicsLayerMosaicsCampaign.remove(this.PointGraphicMosaicsCampaigns[j])
            }
          }
        }
        this.map.remove(this.layerMosaicsGeneral, 0)
      }
    },
    filterMosaicsCampaigns () {
      if(this.areCampaignMosaicsVisible && this.isLayerMosaicsVisible){
        for (var i=0; i< this.currentLayerMosaicsCampaigns.length; i++){
          for (var j=0; j<this.layerMosaicsCampaigns.length; j++){
            if(this.currentLayerMosaicsCampaigns[i] == this.layerMosaicsCampaigns[j][0]){
              this.layerMosaicsGeneral.remove(this.layerMosaicsCampaigns[j][1], 0)
              this.GraphicsLayerMosaicsCampaign.remove(this.PointGraphicMosaicsCampaigns[j])
            }
          }
        }
        this.reloadfiltrado()
        this.statusReload = !this.statusReload

        this.currentLayerMosaicsCampaigns = []
        for (var i=0; i< this.mosaicsCampaignsListFiltered.length; i++){
          this.currentLayerMosaicsCampaigns.push(this.mosaicsCampaignsListFiltered[i].campaign_id)
        }

        this.switchMosaicsCampaigns()
      }
    },

    // SONARS METHODS

    loadSonarsGlobal () {
      loadModules(['esri/views/MapView', 'esri/layers/WMSLayer','esri/layers/GroupLayer'], {css: true})
      .then(([MapView, WMSLayer, GroupLayer]) => {
        this.layerSonarsGlobal = new WMSLayer({
          url: process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/Global_sonar/wms"
        })
        // Inicializo una capa auxiliar necesaria para poder actualizar las subcapas de mosaicos/batimetrías al usar las funciones de filtrado
        this.reloadLayer = new GroupLayer();
      })
    },

    loadSonarsCampaigns () {
      loadModules(['esri/views/MapView', 'esri/layers/WMSLayer', 'esri/layers/GroupLayer'], {css: true})
      .then(async ([MapView, WMSLayer,GroupLayer]) => {
        if(this.sonarsCampaignsList.length>0){
          if(this.layerSonarsGeneral.length == 0){
            this.layerSonarsGeneral = new GroupLayer()
            this.map.add(this.layerSonarsGeneral)
            this.layerSonarsCampaigns = []
          }
          this.currentLayerSonarsCampaigns = []
          if(this.layerSonarsCampaigns.length == 0){
            for (var i=0; i< this.sonarsCampaignsList.length; i++){
              this.layerSonarsCampaigns.push([
                this.sonarsCampaignsList[i].campaign_id,
                new WMSLayer({
                  url: process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/sonar_campaign_" + this.sonarsCampaignsList[i].campaign_id + "/wms"
                })
              ])

              this.currentLayerSonarsCampaigns.push(this.sonarsCampaignsList[i].campaign_id)
              var url = process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/sonar_campaign_" + this.sonarsCampaignsList[i].campaign_id + "/wms?request=GetCapabilities"
              await getOutsideData(url).then(res=> {
                var result = convert.xml2json(res.data, {compact: true})
                this.coordinatesSonarsCampaigns.push(JSON.parse(result))
                if(this.sonarsCampaignsList.length == this.coordinatesSonarsCampaigns.length){
                   this.loadSonarsMarker()
                }
              })
            }
          }else {
            var layerSonarsCampaignsAux = this.layerSonarsCampaigns
            for (var i=0; i< this.sonarsCampaignsList.length; i++){
              var layerExist = false
              for (let j = 0; j < layerSonarsCampaignsAux.length; j++) {
                if(this.sonarsCampaignsList[i].campaign_id == layerSonarsCampaignsAux[j][0]){
                  layerExist = true
                  break
                }
              }
              // Solo añadimos la capa si no existía previamente
              if(!layerExist){
                this.layerSonarsCampaigns.push([
                  this.sonarsCampaignsList[i].campaign_id,
                  new WMSLayer({
                    url: process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/sonar_campaign_" + this.sonarsCampaignsList[i].campaign_id + "/wms"
                  })
                ]);

                this.currentLayerSonarsCampaigns.push(this.sonarsCampaignsList[i].campaign_id)
                var url = process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/sonar_campaign_" + this.sonarsCampaignsList[i].campaign_id + "/wms?request=GetCapabilities"
                await getOutsideData(url).then(res=> {
                  var result = convert.xml2json(res.data, {compact: true});
                  this.coordinatesSonarsCampaigns.push(JSON.parse(result))
                  if(this.sonarsCampaignsList.length == this.coordinatesSonarsCampaigns.length){
                    this.loadSonarsMarker()
                  }
                })
              }
            }
          }
        }
      })
    },

    switchSonarsGlobal () {
      if(this.isGlobalSonarVisible && this.isLayerSonarsVisible){
       this.map.add(this.layerSonarsGlobal, 0)
      }else{
        this.map.remove(this.layerSonarsGlobal, 0)
      }
    },

    switchSonarsCampaigns () {
      if(this.areCampaignSonarsVisible && this.isLayerSonarsVisible){
        for (var i=0; i< this.sonarsCampaignsListFiltered.length; i++){
          for (var j=0; j<this.layerSonarsCampaigns.length; j++){
            if(this.sonarsCampaignsListFiltered[i].campaign_id == this.layerSonarsCampaigns[j][0]){
              this.layerSonarsGeneral.add(this.layerSonarsCampaigns[j][1], 0)
              this.GraphicsLayerSonarsCampaign.add(this.PointGraphicSonarsCampaigns[j])
            }
          }
        }
        this.map.add(this.layerSonarsGeneral)
      }
      else {
        for (var i=0; i< this.sonarsCampaignsListFiltered.length; i++){
          for (var j=0; j<this.layerSonarsCampaigns.length; j++){
            if(this.sonarsCampaignsListFiltered[i].campaign_id == this.layerSonarsCampaigns[j][0]){
              this.layerSonarsGeneral.remove(this.layerSonarsCampaigns[j][1], 0)
              this.GraphicsLayerSonarsCampaign.remove(this.PointGraphicSonarsCampaigns[j])
            }
          }
        }
        this.map.remove(this.layerSonarsGeneral, 0)
      }
    },

    loadSonarsMarker () {
      loadModules(['esri/views/MapView', "esri/Graphic","esri/layers/GraphicsLayer"], {css: true})
        .then(([MapView, Graphic,GraphicsLayer]) => {
          this.GraphicsLayerSonarsCampaign = new GraphicsLayer()
          this.map.add(this.GraphicsLayerSonarsCampaign)
          this.PointGraphicSonarsCampaigns = []
          var i = 0
          this.coordinatesSonarsCampaigns.forEach(item => {
            this.PointGraphicSonarsCampaigns.push(new Graphic({
                geometry: {
                  type: "point",
                  longitude: item.WMS_Capabilities.Capability.Layer.EX_GeographicBoundingBox.eastBoundLongitude['_text'],
                  latitude: item.WMS_Capabilities.Capability.Layer.EX_GeographicBoundingBox.northBoundLatitude['_text'],

                },
                symbol: this.regularGraphic,
                attributes: {
                  //Name: item.WMS_Capabilities.Capability.Layer.Layer.Name['_text'],
                  Name: this.sonarsCampaignsList[i].name,
                  Date: this.sonarsCampaignsList[i].date,
                  index: i
                },
                popupTemplate: {
                  title: "{Name}",
                  content: "<p>{Date}<p>",
                  actions: [{
                      title: "Ver detalles",
                      id: 'view_details',
                      index: i,
                      tipo: 'sonar',
                      image: "Measure_Distance16.png"
                  }],
                }
            }))
            //this.GraphicsLayerMosaicsCampaign.add(this.PointGraphicMosaicsCampaigns[i]);
            i++
          })
          //this.handlePopup()
      })

    },

    filterSonarsCampaigns () {
      if(this.areCampaignSonarsVisible && this.isLayerSonarsVisible){
        for (var i=0; i< this.currentLayerSonarsCampaigns.length; i++){
          for (var j=0; j<this.layerSonarsCampaigns.length; j++){
            if(this.currentLayerSonarsCampaigns[i] == this.layerSonarsCampaigns[j][0]){
              this.layerSonarsGeneral.remove(this.layerSonarsCampaigns[j][1], 0)
              this.GraphicsLayerSonarsCampaign.remove(this.PointGraphicSonarsCampaigns[j])
            }
          }
        }
        this.reloadfiltrado()
        this.statusReload = !this.statusReload

        this.currentLayerSonarsCampaigns = []
        for (var i=0; i< this.sonarsCampaignsListFiltered.length; i++){
          this.currentLayerSonarsCampaigns.push(this.sonarsCampaignsListFiltered[i].campaign_id)
        }

        this.switchSonarsCampaigns()
      }
    },

    // PARAMS METHODS
    switchParamsStations () {
      if(this.isLayerParamsVisible && this.areStationsVisible){
        this.addPlatformMarker()
      }else{
        this.map.remove(this.platformGraphicsLayer, 0)
      }
    },
    switchParamsDensity () {
      this.map.remove(this.layerParamsDensityMap, 0)
      if(this.isLayerParamsVisible && this.areDensityMapsVisible){
        loadModules(['esri/views/MapView', 'esri/layers/WMSLayer'], {css: true})
        .then(([MapView, WMSLayer]) => {
          this.layerParamsDensityMap = new WMSLayer({
            url: process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/water_parameter_" + this.paramsCampaignSelected.id + "_" + this.densitySelectedParam + "/wms"
          })
          let url = process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/water_parameter_" + this.paramsCampaignSelected.id + "_" + this.densitySelectedParam + "/wms?request=GetCapabilities"
          getOutsideData(url).then(res=> {
                let result = JSON.parse(convert.xml2json(res.data, {compact: true}))
                let legendUrl = result.WMS_Capabilities.Capability.Layer.Layer.Style.LegendURL.OnlineResource._attributes["xlink:href"]
                this.$store.dispatch('changeLegendURLStatus', legendUrl)
                console.log(this.legendURL)
              })
          this.map.add(this.layerParamsDensityMap, 0)
        })
      }
    },
    addPlatformMarker () {
      loadModules(['esri/views/MapView', "esri/Graphic","esri/layers/GraphicsLayer"], {css: true})
        .then(([MapView, Graphic,GraphicsLayer]) => {
          this.platformGraphicsLayer = new GraphicsLayer();
          this.map.add(this.platformGraphicsLayer);
          this.platforms.forEach(platform => {
            if(platform.geometry) {
              var pointGraphic = new Graphic({
                geometry: {
                  type: "point",
                  longitude: platform.geometry.coordinates[0],
                  latitude: platform.geometry.coordinates[1]
                },
                symbol: this.regularGraphic,
                attributes: {
                  id: platform.properties.pk,
                  Name: platform.properties.name,
                  Description: platform.properties.description,
                },
                /*popupTemplate: {
                  title: "{Name}",
                  //content: "<p>{Description}<p>",
                  actions: [{
                    title: "Ver datos",
                    id: platform.properties.pk,
                    image: "Measure_Distance16.png"
                  }],
                }*/
              });
              this.platformGraphicsLayer.add(pointGraphic);
            }
          });
        })
    },

    getPlatformList: function () {
      var url = 'campaign/platforms/'
      getData(url).then(res=> {
        this.platforms=res.data.platforms
      })
    },

    //BATHYMETRY METHODS
    loadBathymetryGlobal () {
      loadModules(['esri/views/MapView', 'esri/layers/WMSLayer'], {css: true})
      .then(([MapView, WMSLayer]) => {
        this.layerBathymetryGlobal = new WMSLayer({
          url: process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/Global_bathymetry/wms"
        })
      });
    },
    switchBathymetryGlobal () {
      if(this.isGlobalBathymetryVisible && this.isLayerBathymetryVisible){
        this.map.add(this.layerBathymetryGlobal, 0)
      }else{
        this.map.remove(this.layerBathymetryGlobal, 0)
      }
    },
    loadBathymetryCampaigns () {
      loadModules(['esri/views/MapView', 'esri/layers/WMSLayer', 'esri/layers/GroupLayer'], {css: true})
      .then(async ([MapView, WMSLayer,GroupLayer]) => {
        if(this.bathymetryCampaignsList.length>0){
          if(this.layerBathymetryGeneral.length == 0){
            this.layerBathymetryGeneral = new GroupLayer()
            this.map.add(this.layerBathymetryGeneral)
            this.layerBathymetryCampaigns = []
          }
          this.currentLayerBathymetryCampaigns = []

          if(this.layerBathymetryCampaigns.length == 0){
            for (var i=0; i< this.bathymetryCampaignsList.length; i++){
              this.layerBathymetryCampaigns.push([
                this.bathymetryCampaignsList[i].campaign_id,
                new WMSLayer({
                  url: process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/bathymetry_campaign_" + this.bathymetryCampaignsList[i].campaign_id + "/wms"
                })
              ]);
              this.currentLayerBathymetryCampaigns.push(this.bathymetryCampaignsList[i].campaign_id)
              var url = process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/bathymetry_campaign_" + this.bathymetryCampaignsList[i].campaign_id + "/wms?request=GetCapabilities"
              await getOutsideData(url).then(res=> {
                var result = convert.xml2json(res.data, {compact: true});
                this.coordinatesBathymetryCampaigns.push(JSON.parse(result))
                if(this.bathymetryCampaignsList.length == this.coordinatesBathymetryCampaigns.length){
                   this.loadBathymetryMarker()
                }
              })
            }
          }else{
            var layerBathymetryCampaignsAux = this.layerBathymetryCampaigns
            for (var i=0; i< this.bathymetryCampaignsList.length; i++){
              var layerExist = false
              for (let j = 0; j < layerBathymetryCampaignsAux.length; j++) {
                if(this.bathymetryCampaignsList[i].campaign_id != layerBathymetryCampaignsAux[j][0] ){
                  layerExist = true
                  break
                }
              }
              // Solo añadimos la capa si no existía previamente
              if(!layerExist){
                this.layerBathymetryCampaigns.push([
                this.bathymetryCampaignsList[i].campaign_id,
                  new WMSLayer({
                    url: process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/bathymetry_campaign_" + this.bathymetryCampaignsList[i].campaign_id + "/wms"
                  })
                ]);
                this.currentLayerBathymetryCampaigns.push(this.bathymetryCampaignsList[i].campaign_id)
                var url = process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/bathymetry_campaign_" + this.bathymetryCampaignsList[i].campaign_id + "/wms?request=GetCapabilities"
                await getOutsideData(url).then(res=> {
                  var result = convert.xml2json(res.data, {compact: true});
                  this.coordinatesBathymetryCampaigns.push(JSON.parse(result))
                  if(this.bathymetryCampaignsList.length == this.coordinatesBathymetryCampaigns.length){
                    his.loadBathymetryMarker()
                  }
                })
              }
            }
          }
        }
      })
    },
    switchBathymetryCampaigns () {
      if(this.areCampaignBathymetryVisible && this.isLayerBathymetryVisible){
        for (var i=0; i< this.bathymetryCampaignsListFiltered.length; i++){
          for (var j=0; j<this.layerBathymetryCampaigns.length; j++){
            if(this.bathymetryCampaignsListFiltered[i].campaign_id == this.layerBathymetryCampaigns[j][0]){
              this.layerBathymetryGeneral.add(this.layerBathymetryCampaigns[j][1], 0)
              this.GraphicsLayerBathymetryCampaign.add(this.PointGraphicBathymetryCampaigns[j]);
            }
          }
        }
        this.map.add(this.layerBathymetryGeneral)
      }
      else {
        for (var i=0; i< this.bathymetryCampaignsListFiltered.length; i++){
          for (var j=0; j<this.layerBathymetryCampaigns.length; j++){
            if(this.bathymetryCampaignsListFiltered[i].campaign_id == this.layerBathymetryCampaigns[j][0]){
              this.layerBathymetryGeneral.remove(this.layerBathymetryCampaigns[j][1], 0)
              this.GraphicsLayerBathymetryCampaign.remove(this.PointGraphicBathymetryCampaigns[j]);
            }
          }
        }
        this.map.remove(this.layerBathymetryGlobal, 0)
      }
    },
    filterBathymetryCampaigns () {
      if(this.areCampaignBathymetryVisible && this.isLayerBathymetryVisible){
        for (var i=0; i< this.currentLayerBathymetryCampaigns.length; i++){
          for (var j=0; j<this.layerBathymetryCampaigns.length; j++){
            if(this.currentLayerBathymetryCampaigns[i] == this.layerBathymetryCampaigns[j][0]){
              this.layerBathymetryGeneral.remove(this.layerBathymetryCampaigns[j][1], 0)
              this.GraphicsLayerBathymetryCampaign.remove(this.PointGraphicBathymetryCampaigns[j])
            }
          }
        }

        this.reloadfiltrado()
        this.statusReload = !this.statusReload

        this.currentLayerBathymetryCampaigns = []
        for (var i=0; i< this.bathymetryCampaignsListFiltered.length; i++){
          this.currentLayerBathymetryCampaigns.push(this.bathymetryCampaignsListFiltered[i].campaign_id)
        }
        this.switchBathymetryCampaigns()
      }
    },
    reloadfiltrado(){
      if(this.statusReload) {
        this.map.add(this.reloadLayer, 0)
      }else {
        this.map.remove(this.reloadLayer, 0)
      }

    },
    loadBathymetryMarker () {
      loadModules(['esri/views/MapView', "esri/Graphic","esri/layers/GraphicsLayer"], {css: true})
        .then(([MapView, Graphic,GraphicsLayer]) => {
          this.GraphicsLayerBathymetryCampaign = new GraphicsLayer();
          this.map.add(this.GraphicsLayerBathymetryCampaign)
          this.PointGraphicBathymetryCampaigns = []
          var i = 0
          this.coordinatesBathymetryCampaigns.forEach(item => {
          this.PointGraphicBathymetryCampaigns.push(new Graphic({
              geometry: {
                 type: "point",
                 longitude: item.WMS_Capabilities.Capability.Layer.EX_GeographicBoundingBox.eastBoundLongitude['_text'],
                 latitude: item.WMS_Capabilities.Capability.Layer.EX_GeographicBoundingBox.northBoundLatitude['_text']
              },
              symbol:{
                type: "simple-marker",
                 color: [52, 152, 219],
                outline: {
                  color: [255, 255, 255],
                  width: 1
                }
              },
              attributes: {
                //Name: item.WMS_Capabilities.Capability.Layer.Layer.Name['_text'],
                Name: this.bathymetryCampaignsList[i].name,
                Date: this.bathymetryCampaignsList[i].date,
                index: i
              },
              popupTemplate: {
                title: "{Name}",
                content: "<p>{Date}<p>",
                actions: [{
                    title: "Ver detalles",
                    id: 'view_details',
                    tipo: 'bathymetry',
                    image: "Measure_Distance16.png",
                    index: i
                }],
              }
           }));
            //this.GraphicsLayerBathymetryCampaign.add(this.PointGraphicBathymetryCampaigns[i]);
            i++
          });
      })
    },

    // GENERAL METHODS
    handleClickEvent () {
      setTimeout(() => {
        loadModules(['esri/Map', 'esri/views/MapView'], {css: true})
        .then(([ArcGISMap, MapView]) => {
        let thisGlobal = this
        // Get the screen point from the view's click event

        this.view.on("click", function (event) {
          let screenPoint = {
            x: event.x,
            y: event.y
          };
          // Search for graphics at the clicked location
          thisGlobal.view.hitTest(screenPoint).then(function (response) {
            if (response.results.length) {
              let graphicLayer = response.results.filter(function (result) {
                // check if the graphic belongs to the layer of interest
                if (thisGlobal.isLayerMosaicsVisible) {
                    return result.graphic.layer === thisGlobal.GraphicsLayerMosaicsCampaign
                } else if (thisGlobal.isLayerParamsVisible) {
                    return result.graphic.layer === thisGlobal.platformGraphicsLayer
                } else if (thisGlobal.isLayerBathymetryVisible)  {
                    return result.graphic.layer === thisGlobal.GraphicsLayerBathymetryCampaign
                } else if (thisGlobal.isLayerSonarsVisible)  {
                    return result.graphic.layer === thisGlobal.GraphicsLayerSonarsCampaign
                }
              })
              if(graphicLayer[0]){

                let graphic = graphicLayer[0].graphic
                // do something with the result graphic
                if(thisGlobal.isLayerParamsVisible) {
                  // do something with the result graphic
                  if(graphic.attributes.id){
                      thisGlobal.$store.commit('set_platform_id', graphic.attributes.id)
                      graphic.symbol = thisGlobal.selectedGraphic
                      if(thisGlobal.selectedGraphicObject  && thisGlobal.selectedPointId != graphic.attributes.id){
                        thisGlobal.selectedGraphicObject.symbol = thisGlobal.regularGraphic
                      }
                      thisGlobal.selectedPointId = graphic.attributes.id
                      thisGlobal.selectedGraphicObject = graphic
                    }

                } else if (thisGlobal.isLayerMosaicsVisible) {
                    if(graphic.uid){
                    thisGlobal.$store.commit('set_mosaic_uid', graphic.uid)
                    graphic.symbol = thisGlobal.selectedGraphic

                    if(thisGlobal.selectedGraphicObject  && thisGlobal.selectedPointId != graphic.uid){
                      thisGlobal.selectedGraphicObject.symbol = thisGlobal.regularGraphic
                    }
                    thisGlobal.selectedPointId = graphic.uid
                    thisGlobal.selectedGraphicObject = graphic
                    thisGlobal.$store.dispatch('changeMosaicCampaignSelected', graphic.attributes.index)
                  }
                } else if (thisGlobal.isLayerBathymetryVisible) {
                    if(graphic.uid){
                    thisGlobal.$store.commit('set_bathymetry_uid', graphic.uid)
                    graphic.symbol = thisGlobal.selectedGraphic

                    if(thisGlobal.selectedGraphicObject  && thisGlobal.selectedPointId != graphic.uid){
                      thisGlobal.selectedGraphicObject.symbol = thisGlobal.regularGraphic
                    }
                    thisGlobal.selectedPointId = graphic.uid
                    thisGlobal.selectedGraphicObject = graphic
                    thisGlobal.$store.dispatch('changeBathymetryCampaignSelected', graphic.attributes.index)
                  }
                }else if (thisGlobal.isLayerSonarsVisible) {
                    if(graphic.uid){
                    thisGlobal.$store.commit('set_sonar_uid', graphic.uid)
                    graphic.symbol = thisGlobal.selectedGraphic

                    if(thisGlobal.selectedGraphicObject  && thisGlobal.selectedPointId != graphic.uid){
                      thisGlobal.selectedGraphicObject.symbol = thisGlobal.regularGraphic
                    }
                    thisGlobal.selectedPointId = graphic.uid
                    thisGlobal.selectedGraphicObject = graphic
                    thisGlobal.$store.dispatch('changeSonarCampaignSelected', graphic.attributes.index)
                  }
                }
              }
            }
          })
        })

        this.view.on("pointer-move", function (event) {

          var screenPoint = {
            x: event.x,
            y: event.y,
          };
          // Search for graphics at the clicked location
          thisGlobal.view.hitTest(screenPoint).then(function (response) {

            if (response.results.length) {
              let graphicLayer = response.results.filter(function (result) {
                // check if the graphic belongs to the layer of interest
                if (thisGlobal.isLayerMosaicsVisible) {
                    return result.graphic.layer === thisGlobal.GraphicsLayerMosaicsCampaign
                } else if (thisGlobal.isLayerParamsVisible) {
                    return result.graphic.layer === thisGlobal.platformGraphicsLayer
                } else if (thisGlobal.isLayerBathymetryVisible)  {
                    return result.graphic.layer === thisGlobal.GraphicsLayerBathymetryCampaign
                } else if (thisGlobal.isLayerSonarsVisible)  {
                    return result.graphic.layer === thisGlobal.GraphicsLayerSonarsCampaign
                }
              })
              if(graphicLayer[0]){
                thisGlobal.$refs.map.style.cursor = "pointer"

              } else {
                thisGlobal.$refs.map.style.cursor = "initial"
              }
            }
          })
        })
         this.view.popup.on("trigger-action", function(event) {
          if(event.action.id == 'view_details') {
            console.log(event.action.tipo)
            if(event.action.tipo == 'mosaic'){
              thisGlobal.$store.dispatch('changeMosaicCampaignSelected', event.action.index)
            }
            else if (event.action.tipo == 'bathymetry'){
              thisGlobal.$store.dispatch('changeBathymetryCampaignSelected', event.action.index)
            }
            else if (event.action.tipo == 'sonar'){
              thisGlobal.$store.dispatch('changeSonarCampaignSelected', event.action.index)
            }
          }
        })
      })
      }, 1000)

    },

    loadScaleBar () {
      loadModules(['esri/views/MapView', 'esri/widgets/ScaleBar'], {css: true})
      .then(([MapView, ScaleBar]) => {
        var ScaleBar = new ScaleBar({
          view: this.view,
          unit: "metric"
        });
        this.view.ui.add(ScaleBar, "bottom-left");
      })
    }
  },
  beforeDestroy() {
    if (this.view) {
      // destroy the map view
      this.view.container = null;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .legend img{
      z-index: 1900;
      position: absolute;
      top: 85px;
      left: 16px;
      width: 60px;
    }
  .popup{
    position: absolute;
    display: none;
    background-color: rgba(255,255,255,0.9);
    padding: 20px;
    z-index: 1000;
    pointer-events: none;
    box-shadow: 0px 2px 3px rgba(0,0,0,0.2);
    border-radius: 6px;
  }
  .station-name{
    color: #00a7e3;
    font-weight: 600;
  }

  .geometry-class {
    background-color:pink;
  }

</style>



// WEBPACK FOOTER //
// src/components/Map.vue